import {apiMethods} from "../../controller/Request";
import {Config} from "../../controller/Global";


export const SubContractorGet = (id, params = {}) => {
  const URL = Config['api']['crm']['sub_contractor']['url'] + id + '/';
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const SubContractorList = (params = {}) => {
  const URL = Config['api']['crm']['sub_contractor']['url'];
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const SubContractorPost = (params = {}) => {
   const formData = new FormData();
  Object.keys(params).forEach((key, index) => {
      formData.append(key, params[key])
  });
  const URL = Config['api']['crm']['sub_contractor']['url'];
  return apiMethods.post(URL, formData, true, {})
    .then(response => {
      return response
    })
};
export const SubContractorUpdate = (id, params = {}) => {
 const formData = new FormData();
  Object.keys(params).forEach((key, index) => {
      formData.append(key, params[key])
  });
  const URL = Config['api']['crm']['sub_contractor']['url'] + id + '/';
  return apiMethods.patch(URL, formData, true, {})
    .then(response => {
      return response
    })
};

export const SubContractorRemove = (id, params = {}) => {
  const URL = Config['api']['crm']['sub_contractor']['url'] + id + "/";
  return apiMethods.remove(URL, params, true)
    .then(response => {
      return response
    })
};


export const SubContractorNameList = (params = {}) => {
  const URL = Config['api']['crm']['sub_contractor_name']['url'];
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};


// WEBPACK FOOTER //
// ./src/models/crm/sub_contractor.jsx